<template>
  <div :class="{
    'form-control': deletedCustomer ? false : true,
    'is-select': deletedCustomer ? false : true
  }">
    <span v-if="deletedCustomer">
      {{ customerName }}
      <small
        v-if="!changingCustomer"
        @click.prevent="changeCustomer"
        class="text-primary ml-3 cursor-pointer">
        <i class="material-icons">edit</i> Zmień klienta
      </small>
      <div
        v-else
        class="spinner-border spinner-border-sm"
        role="status"></div>
    </span>
    <v-select
      v-else
      :options="customers"
      v-model="customer_id"
      :reduce="customer => customer.id"
      :filterBy="filterByForCustomers"
      placeholder="Wybierz klienta"
      label="name"
      @search="debouncedFetchCustomers">
      <template slot="no-options">
        <template v-if="!emptyResults">Wyszukiwanie&hellip;</template>
        <template v-if="emptyResults">Brak klientów pasujących do podanej frazy&hellip;</template>
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.name }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'select-customer',
  props: [
    'customerID',
    'customerName'
  ],
  watch: {
    customer_id (newValue) {
      this.$bus.$emit('ui-select-customer-updated', newValue);
    }
  },
  data () {
    return {
      customer_id: null,
      customers: [],
      emptyResults: false,
      loadCustomersError: false,
      deletedCustomer: false,
      changingCustomer: false
    }
  },
  mounted () {
    this.customer_id = this.customerID;

    if (this.customer_id) {
      this.prefetchCustomer(this.customer_id);
    } else {
      this.customer_id = null;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/items',
        outputKey: 'customers',
        errorKey: 'loadCustomersError'
      });
    }
  },
  methods: {
    filterByForCustomers (option, label, search) {
      return (option.name + ' ' + option.email).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchCustomer (customerID) {
      if (!customerID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/item/' + parseInt(customerID, 10),
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        wrapResponseIntoArray: true,
        successAction: (response) => {
          this.customer_id = parseInt(customerID, 10);

          if (!response || !response[0] || !response[0].id) {
            this.deletedCustomer = true;
            this.customers = [];

            Vue.swal({
              title: 'Wybrany klient nie istnieje',
              html: 'Klient, który był przypisany do tego zamówienia, został usunięty. Należy na nowo ustawić klienta w zamówieniu.',
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });

            this.customer_id = null;
            this.deletedCustomer = false;

            FormUtils.loadAdditionalData(this, {
              endpoint: '/customers/items',
              outputKey: 'customers',
              errorKey: 'loadCustomersError'
            });
          }
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/customers/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.customer_id !== 0 && this.customer_id !== null && searchPhrase === '') {
        endpointUrl = '/customers/item/' + parseInt(this.customer_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCustomers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
    changeCustomer () {
      this.changingCustomer = true;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/items',
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        successAction: () => {
          Vue.set(this, 'customer_id', null);
          this.deletedCustomer = false;
          this.changingCustomer = false;
        },
        failAction: () => {
          this.changingCustomer = false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
